import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  GetSoftwaremanagementSoftwareSetupsSelectorDocument,
  GetSoftwaremanagementSoftwareSetupsSelectorQuery,
  VendorSoftwareSetupFragment,
} from 'generated/resources/graphql'

import { EntitySelector } from 'modules/core/components/EntitySelector'
import i18n from 'modules/core/lib/i18n'

import { getSoftware } from 'modules/software_management/lib/software'

import { FinanceSoftwareSelectorMultipleProps, FinanceSoftwareSelectorSingleProps } from './types'

const FinanceSoftwareItem = ({ software }: { software: VendorSoftwareSetupFragment }) => {
  const softwareData = getSoftware(software)

  return (
    <Box gap="s2">
      <Box flexDirection="row" alignItems="center" gap="s8">
        <Text.Normal weight="medium" color="grey1000">
          {softwareData.name}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export const FinanceSoftwareSelector: React.FC<
  FinanceSoftwareSelectorSingleProps | FinanceSoftwareSelectorMultipleProps
> = (props) => {
  const { value, multiple } = props

  const extractConnection = (data: GetSoftwaremanagementSoftwareSetupsSelectorQuery) => {
    return data.softwareManagement.softwareSetupsConnection
  }

  const renderEntity = (entity: VendorSoftwareSetupFragment) => {
    return <FinanceSoftwareItem software={entity} />
  }

  const commonProps = {
    document: GetSoftwaremanagementSoftwareSetupsSelectorDocument,
    extractConnection,
    label: i18n.t('finance.invoices.detail.associated_resource_software_type'),
    renderEntity,
    disabled: props.disabled,
    variables: {},
  }

  if (multiple) {
    const selectorProps = { ...commonProps, ...props }

    return (
      <EntitySelector.Multiple
        {...selectorProps}
        renderValue={(softwareSetups) => (
          <Text.Normal ellipsis>
            {softwareSetups.length > 0
              ? softwareSetups.map((setup) => getSoftware(setup).name).join(', ')
              : i18n.t('common.select_multiple')}
          </Text.Normal>
        )}
      />
    )
  }

  const selectorProps = { ...commonProps, ...props }

  return (
    <EntitySelector
      {...selectorProps}
      renderValue={(entity) =>
        entity !== null && entity != undefined ? (
          <Text.Normal ellipsis>{getSoftware(entity).name}</Text.Normal>
        ) : (
          <Text.Normal>{i18n.t('common.select')}</Text.Normal>
        )
      }
    />
  )
}
